export const queryParams = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');
